// extracted by mini-css-extract-plugin
export default {"searchContainer":"Travellers_searchContainer__Fy4-c","search":"Travellers_search__e8UZ9","emptyContainer":"Travellers_emptyContainer__dwJlx","spinner":"Travellers_spinner__4WeK-"};